//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {StarLevel} from '@/components';

export default {
  name: 'hotel-box',
  components: {
    StarLevel,
  },
  props: {
    data: {
      type: Object,
      default(){
        return {};
      },
    },
    hasSelected: Boolean,
  },
  data(){
    return {
      isShowBox: false,
    };
  },
  computed: {
    lanType(){
      return +window.localStorage.getItem('lan_type');
    },
  },
  watch: {
    data(cur){
      if(Object.keys(cur).length > 0){
        this.animate();
      }
    },
  },
  methods: {
    animate(){
      // this.hideBox();

      // setTimeout(() => {
      //   this.showBox();
      // }, 520);
      this.showBox();
    },

    /** 打开酒店筛选 */
    onOpenFilter(){
      this.$emit('on-open-filter');
    },

    /** 路由到酒店详情 */
    onLink(){
      this.$emit('on-link', this.data);
    },

    /** 显示酒店信息 */
    showBox(){
      this.isShowBox = true;
      // this.$refs.animateBox.style.transform = 'translateY(0)'
    },

    /** 返回酒店列表 */
    onBackToList(){
      window.history.go(-1);
    },

    onCloseBox(){
      this.isShowBox = false;
      this.$emit('on-close');
    },

    /** 隐藏酒店信息 */
    // hideBox(){
      // this.isShowBox = false;
      // const boxH = this.$refs.animateBox.offsetHeight;
      // const filterH = this.$refs.filterButton.offsetHeight + 60;
      // const rootFontSize = document.documentElement.style.fontSize.replace('px', '');
      // console.log(rootFontSize);
      // console.log(this.$refs.animateBox.offsetHeight);
      // console.log(this.$refs.filterButton.offsetHeight);
      // this.$refs.animateBox.style.transform = `translateY(${(boxH - filterH) / Number(rootFontSize)}rem)`
    // },
  }
}



// WEBPACK FOOTER //
// ./src/views/map/components/HotelBox.vue